<template lang="pug">
    v-card(
        v-if="validDayDashboardSummary && validHourlyDashboardSummaries"
        style="height: 500px !important;"
        elevation="4"
        shaped
    )
        v-card-text(
            style="height: 100%; width: 100%;"
        )
            line-chart(
                style="height: 100%; width: 100%;"
                :data="data"
                :min="0"
                :xtitle="xAxisTitle"
                ytitle="Activity %"
            )

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    import Chartkick from 'vue-chartkick';
    import Chart from 'chart.js';

    Vue.use(Chartkick.use(Chart));

    export default Vue.extend({
        data() {
            return {
                data: [],
            }
        },
        methods: {
            buildGraph() {

                // Verify (this could be null during initial load)
                if (!this.validHourlyDashboardSummaries || !this.validDayDashboardSummary) {
                    return this.initData();
                }
                // start from a fresh base each time
                const next = [
                    { name: 'Incoming Messages', data: { ...this.data[0]?.data } },
                    { name: 'Outgoing Ad Hoc Messages', data: { ...this.data[1]?.data } },
                    { name: 'Outgoing Campaign Customer Messages', data: { ...this.data[2]?.data } },
                    { name: 'Outgoing Follow Up Messages', data: { ...this.data[3]?.data } },
                    { name: 'Waiting Messages Responded To', data: { ...this.data[4]?.data } },
                ];

                for (let i = 0; i < this.hourlyDashboardSummaries.length; i++) {

                    // Get period
                    const period = this.hourlyDashboardSummaries[i];
                    if (!period || period.period_type !== "hour" || !(period.id > 0)) {
                        continue;
                    }

                    // Get key
                    const key = this.getKey(period);
                    if (!key) {
                        continue;
                    }

                    // idx 0 is incoming messages
                    next[0].data[key] = this.calculatePercentage(period.message_incoming_message_count || 0, this.currentDayDashboardSummary.message_incoming_message_count || 0);

                    // idx 1 is outgoing customer messages
                    next[1].data[key] = this.calculatePercentage(period.message_outgoing_customer_message_count || 0, this.currentDayDashboardSummary.message_outgoing_customer_message_count || 0);

                    // idx 2 is outgoing campaign customer messages
                    next[2].data[key] = this.calculatePercentage(period.message_outgoing_campaign_customer_message_count || 0, this.currentDayDashboardSummary.message_outgoing_campaign_customer_message_count || 0);

                    // idx 3 is outgoing follow ups messages
                    next[3].data[key] = this.calculatePercentage(period.message_outgoing_follow_up_message_count || 0, this.currentDayDashboardSummary.message_outgoing_follow_up_message_count || 0);

                    // idx 4 is message responded
                    next[4].data[key] = this.calculatePercentage(period.message_responded_message_count || 0, this.currentDayDashboardSummary.message_responded_message_count || 0);
                }

                this.data = next;
            },
            calculatePercentage(a, b) {

                // Ensure valid b
                if (b <= 0) {
                    return '0';
                }

                return ((a * 1.0) / (b * 1.0) * 100.0).toFixed(0);
            },
            getKey(child) {
                let key = null;
                if (!child || !child.begin_time) {
                    return key;
                }

                // Init
                const beginTime = new Date(child.begin_time);
                if (!beginTime) {
                    return key;
                }

                // Determine hours
                const hours = beginTime.getUTCHours();
                if (hours === 0) {
                    key = "12am";
                } else if (hours === 12) {
                    key = "12pm";
                } else if (hours > 12) {
                    key = (hours % 12).toString() + "pm";
                } else {
                    key = hours.toString() + "am";
                }

                return key;
            },
            initData() {
                this.data = [
                    {
                        name: 'Incoming Messages',
                        data: {
                            '12am': 0,
                            '1am': 0,
                            '2am': 0,
                            '3am': 0,
                            '4am': 0,
                            '5am': 0,
                            '6am': 0,
                            '7am': 0,
                            '8am': 0,
                            '9am': 0,
                            '10am': 0,
                            '11am': 0,
                            '12pm': 0,
                            '1pm': 0,
                            '2pm': 0,
                            '3pm': 0,
                            '4pm': 0,
                            '5pm': 0,
                            '6pm': 0,
                            '7pm': 0,
                            '8pm': 0,
                            '9pm': 0,
                            '10pm': 0,
                            '11pm': 0,
                        }
                    },
                    {
                        name: 'Outgoing Ad Hoc Messages',
                        data: {
                            '12am': 0,
                            '1am': 0,
                            '2am': 0,
                            '3am': 0,
                            '4am': 0,
                            '5am': 0,
                            '6am': 0,
                            '7am': 0,
                            '8am': 0,
                            '9am': 0,
                            '10am': 0,
                            '11am': 0,
                            '12pm': 0,
                            '1pm': 0,
                            '2pm': 0,
                            '3pm': 0,
                            '4pm': 0,
                            '5pm': 0,
                            '6pm': 0,
                            '7pm': 0,
                            '8pm': 0,
                            '9pm': 0,
                            '10pm': 0,
                            '11pm': 0,
                        }
                    },
                    {
                        name: 'Outgoing Campaign Customer Messages',
                        data: {
                            '12am': 0,
                            '1am': 0,
                            '2am': 0,
                            '3am': 0,
                            '4am': 0,
                            '5am': 0,
                            '6am': 0,
                            '7am': 0,
                            '8am': 0,
                            '9am': 0,
                            '10am': 0,
                            '11am': 0,
                            '12pm': 0,
                            '1pm': 0,
                            '2pm': 0,
                            '3pm': 0,
                            '4pm': 0,
                            '5pm': 0,
                            '6pm': 0,
                            '7pm': 0,
                            '8pm': 0,
                            '9pm': 0,
                            '10pm': 0,
                            '11pm': 0,
                        }
                    },
                    {
                        name: 'Outgoing Follow Up Messages',
                        data: {
                            '12am': 0,
                            '1am': 0,
                            '2am': 0,
                            '3am': 0,
                            '4am': 0,
                            '5am': 0,
                            '6am': 0,
                            '7am': 0,
                            '8am': 0,
                            '9am': 0,
                            '10am': 0,
                            '11am': 0,
                            '12pm': 0,
                            '1pm': 0,
                            '2pm': 0,
                            '3pm': 0,
                            '4pm': 0,
                            '5pm': 0,
                            '6pm': 0,
                            '7pm': 0,
                            '8pm': 0,
                            '9pm': 0,
                            '10pm': 0,
                            '11pm': 0,
                        }
                    },
                    {
                        name: 'Waiting Messages Responded To',
                        data: {
                            '12am': 0,
                            '1am': 0,
                            '2am': 0,
                            '3am': 0,
                            '4am': 0,
                            '5am': 0,
                            '6am': 0,
                            '7am': 0,
                            '8am': 0,
                            '9am': 0,
                            '10am': 0,
                            '11am': 0,
                            '12pm': 0,
                            '1pm': 0,
                            '2pm': 0,
                            '3pm': 0,
                            '4pm': 0,
                            '5pm': 0,
                            '6pm': 0,
                            '7pm': 0,
                            '8pm': 0,
                            '9pm': 0,
                            '10pm': 0,
                            '11pm': 0,
                        }
                    },
                ];
            },
        },
        computed: {
            xAxisTitle() {
                return (new Date()).toLocaleDateString();
            },
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
            validHourlyDashboardSummaries() {
                return this.hourlyDashboardSummaries?.length > 0;
            },
        },
        components: {
        },
        props: {
            currentDayDashboardSummary: Object,
            hourlyDashboardSummaries: Array,
        },
        watch: {
            hourlyDashboardSummaries: {
                deep: true,
                handler() {
                    console.log("hourlyDashboardSummaries changed: ", this.hourlyDashboardSummaries.length);
                    this.buildGraph();
                },
            },
        },
        destroyed() {
        },
        created() {
            this.initData();
            this.buildGraph();
        },
    });
</script>

<style lang="scss" scoped>
</style>